import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { categoryProps, configurationProp, negativeBalanceProp } from 'src/app/interfaces/iresponse';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';
import { UtilService } from 'src/app/services/utilService/util.service';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css']
})
export class ConfigurationsComponent implements OnInit, OnDestroy {
  breadCrumb: any;
  categories: Array<categoryProps> = [];
  loadingData: boolean = false;
  changeOccured:boolean = true;
  submitting:boolean = false;
  toggled:boolean = false;
  deleting:boolean = false;
  loadingConfiguration:boolean = false;
  updating:boolean = false;
  categoryId: number = 0;
  sub!:Subscription;
  negativeBalance: Array<negativeBalanceProp> = [
    {id: 1, value: true}
  ]
  filters:Array<genderType> = [
    {id: 1, value: '', name: 'Filter category'},
    {id: 2, value: 'active', name: 'Active'},
    {id: 3, value: 'inactive', name: 'InActive'},
  ];
  constructor(
    private userService:UserService, 
    private bootstrapNotifyService: BootstrapNotifyService,
    private utilService: UtilService) { }
  categoryForm = new FormGroup({
    name: new FormControl('', Validators.required),
    daily_fee: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
    enrollment_fee: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)])
  })

  configurtionSettings = new FormGroup({
    allow_negative_balance: new FormControl(null, Validators.required),
    negative_balance_limit: new FormControl(null, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
    sync_max_age: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
    sync_max_batch: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
    ops_near_limit_amount: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
  })

  filterForm = new FormGroup({
    status: new FormControl('', Validators.required)
  })

  ngOnInit() {
    this.getCategory();
    this.getConfiguration();
    this.breadCrumb  = {
      name: 'Configuration',
      parent: 'Settings',
      subLink: null
    };
    

    this.sub = this.configurtionSettings.get('allow_negative_balance')?.valueChanges.subscribe((isValid: any)=>{
      const negativeLimit = this.configurtionSettings.get('negative_balance_limit');
      if(Boolean(isValid === 'true')){
        negativeLimit.enable()
      } else {
        negativeLimit.disable()
      }
      if(typeof isValid === 'boolean' &&  isValid === true){
        negativeLimit.enable();
      }
      this.configurtionSettings.updateValueAndValidity();
    })
  }

  getCategory(){
    this.loadingData = true;
    this.changeOccured = false;
    const filterValue = this.filterForm.get('status').value;
    this.userService.getCategories(filterValue).subscribe({
      next: (response)=>{
        this.changeOccured = true;
        this.utilService.startDatatable('categories')
        this.categories = response;
      },
      error: (err)=>{
        this.changeOccured = true;
        this.utilService.startDatatable('categories');
      }
    }).add(()=> this.loadingData = false)
  }

  onFilterBy(){
    if(this.filterForm.invalid) return;
    this.getCategory();
  }

  toggleAgentStatus(id: number, status: string){
    this.categoryId = id;
    this.toggled = true;
    this.utilService.confirmAction(()=>{
      this.userService.toggleCategory({category_id: id, action: status}).subscribe({
        next:(response)=>{
          this.getCategory();
        }
      }).add(()=> this.toggled = false)
    }, ()=>{
      this.toggled = false
    })
  }

  addCategory(){
    this.utilService.openModal('categoryModal');
  }

  addCategoryForm(){
    if(this.categoryForm.invalid){
      return;
    }
    this.submitting = true;
    this.userService.postCategory(this.categoryForm.value).subscribe({
      next:(response)=>{
        this.categoryForm.reset();
        this.getCategory();
        this.utilService.closeModal('categoryModal');
      },
      error: (error)=>{
        this.submitting = false;
      }
    }).add(()=>this.submitting = false);
  }

  deleteCategory(id: number){
    this.deleting = true;
    return this.userService.deleteCategory(id).subscribe({
      next: (response)=>{
        this.getCategory();
      }
    }).add(() => this.deleting = false)
  }

  getConfiguration(){
    this.loadingConfiguration = true;
    return this.userService.getConfigurationSettings().subscribe({
      next: (response)=>{
        const {allow_negative_balance, negative_balance_limit} = response.wallet_overdraft;
        const {sync_max_age, sync_max_batch, ops_near_limit_amount} = response.ticket;
        let currentLimit;
        if(!allow_negative_balance){
          currentLimit = {id: 2, value: false};
          const duplicate = this.negativeBalance.some((d)=> currentLimit.id === d.id);
          if(duplicate){
            return;
          }else{
            this.negativeBalance.push(currentLimit);
          }
        }else{
          currentLimit = {id: 2, value: false};
          const duplicate = this.negativeBalance.some((d)=> currentLimit.id === d.id);
          if(duplicate){
            return;
          }else{
            this.negativeBalance.push(currentLimit)
          }
        }
        this.configurtionSettings.patchValue(
          {allow_negative_balance, 
            negative_balance_limit: Number(negative_balance_limit),
            sync_max_age, sync_max_batch, ops_near_limit_amount: Number(ops_near_limit_amount)
          });
      },
      error: (err)=>{
        this.bootstrapNotifyService.error(err.error.message);
      }
    }).add(()=> this.loadingConfiguration = false)
  }

  submitConfiguration(){
    if(this.configurtionSettings.invalid){
      return;
    }
    const negativeBal =  this.configurtionSettings.get('allow_negative_balance')?.value;
    const negativeBalanceLimit =  this.configurtionSettings.get('negative_balance_limit')?.value;
    const maxAge =  this.configurtionSettings.get('sync_max_age')?.value;
    const maxBatch =  this.configurtionSettings.get('sync_max_batch')?.value;
    const limitAmount =  this.configurtionSettings.get('ops_near_limit_amount')?.value;
    this.updating = true;
    const payload = {
      wallet_overdraft:{
        allow_negative_balance: Boolean(negativeBal) === true ? false : true,
        negative_balance_limit: negativeBalanceLimit
      },
      ticket:{
        sync_max_age: maxAge,
        sync_max_batch: maxBatch,
        ops_near_limit_amount: limitAmount
      }
    } as configurationProp
    this.userService.postConfiguration(payload).subscribe({
      next:(response)=>{
        this.bootstrapNotifyService.success(response.message);
        this.getConfiguration();
      },
      error: (error)=>{
        const {message} = error.error;
        this.bootstrapNotifyService.error(message);
      }
    }).add(()=> this.updating = false)
  }

  ngOnDestroy(): void {
    if(this.sub) this.sub.unsubscribe();
  }

}
